export default function cloneObject(o) {
    return JSON.parse(JSON.stringify(o));
};